type RandomBytes = Uint8Array<ArrayBuffer>

interface RandomSource {
  randomUUID?: () => string
  fillRandomBytes: (bytes: RandomBytes) => void
}

const browserRandomSource: RandomSource = {
  randomUUID: typeof crypto.randomUUID === 'function' ? () => crypto.randomUUID() : undefined,
  fillRandomBytes: (bytes) => {
    crypto.getRandomValues(bytes)
  },
}

export function createId(source: RandomSource = browserRandomSource): string {
  if (source.randomUUID) return source.randomUUID()

  const bytes: RandomBytes = new Uint8Array(new ArrayBuffer(16))
  source.fillRandomBytes(bytes)
  bytes[6] = (bytes[6] & 0x0f) | 0x40
  bytes[8] = (bytes[8] & 0x3f) | 0x80

  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0'))
  return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10).join('')}`
}
